import { axiosAuthed as axios } from '../axios-config';
import { transformToFE } from './aircraft-model';

export const getAircraft = () =>
  axios
    .get('/integration/timeline/aircrafts')
    .then(resp => resp.data.map(transformToFE))
    .catch(e => {
      throw e;
    });
